import { lazy } from "react";
import { addHandleRoute, createRoute } from "../utils/RouteHelper";

// route
export const reportRoute = createRoute({
    path: "/report",
    name: "menu.report",
    icon: "content_paste",
    accCode: "laporan",
    exclude_breadcrumbs: true,
});

export const rSellingInvoiceRoute = createRoute({
    path: `${reportRoute.path}/inv_out`,
    name: "common_report.sales.",
    accCode: "laporan_penjualan",
    parentCode: reportRoute.accCode,
});

export const rSellingInvoiceDetailRoute = createRoute({
    path: `${reportRoute.path}/inv_out_detail`,
    name: "common_report.sales.detail",
    accCode: "laporan_detail_penjualan",
    parentCode: reportRoute.accCode,
});

export const rPurchInvoiceRoute = createRoute({
    path: `${reportRoute.path}/purchaseInvoice`,
    name: "common_report.purch.",
    accCode: "laporan_pembelian",
    parentCode: reportRoute.accCode,
});

export const rDORoute = createRoute({
    path: `${reportRoute.path}/r-do`,
    name: "common_report.do.",
    accCode: "laporan_delivery_order",
    parentCode: reportRoute.accCode,
});

export const rDODetailRoute = createRoute({
    path: `${reportRoute.path}/r-do_detail`,
    name: "common_report.do.detail",
    accCode: "laporan_detail_delivery_order",
    parentCode: reportRoute.accCode,
});

export const rSORoute = createRoute({
    path: `${reportRoute.path}/r-so`,
    name: "common_report.so.",
    accCode: "laporan_sales_order",
    parentCode: reportRoute.accCode,
});

export const rSODetailRoute = createRoute({
    path: `${reportRoute.path}/r-so_detail`,
    name: "common_report.so.detail",
    accCode: "laporan_detail_sales_order",
    parentCode: reportRoute.accCode,
});

export const rReturnCustomerRoute = createRoute({
    path: `${reportRoute.path}/return_customer`,
    name: "common_report.return_cus.",
    accCode: "laporan_retur_penjualan",
    parentCode: reportRoute.accCode,
});

export const rReturnSupplierRoute = createRoute({
    path: `${reportRoute.path}/return_supplier`,
    name: "common_report.return_sup.",
    accCode: "laporan_retur_pembelian",
    parentCode: reportRoute.accCode,
});

export const rSalesCommissionRoute = createRoute({
    path: `${reportRoute.path}/sales_commission`,
    name: "common_report.sales_commission.",
    accCode: "laporan_komisi_sales",
    parentCode: reportRoute.accCode,
});

export const rStockPriceRoute = createRoute({
    path: `${reportRoute.path}/stock_price`,
    name: "common_report.stock_price.",
    accCode: "laporan_nilai_stock_barang",
    parentCode: reportRoute.accCode,
});

export const rDeliveryRoute = createRoute({
    path: `${reportRoute.path}/delivery`,
    name: "common_report.delivery.",
    accCode: "laporan_pengiriman",
    parentCode: reportRoute.accCode,
});

export const rHPPRoute = createRoute({
    path: `${reportRoute.path}/hpp`,
    name: "common_report.hpp.",
    accCode: "laporan_hpp_jual",
    parentCode: reportRoute.accCode,
});

export const rPaymentSalesRoute = createRoute({
    path: `${reportRoute.path}/rpayment_sales`,
    name: "common_report.payment_sales.",
    accCode: "laporan_pembayaran_penjualan",
    parentCode: reportRoute.accCode,
});

export const rPaymentPurchRoute = createRoute({
    path: `${reportRoute.path}/rpayment_purch`,
    name: "common_report.payment_purch.",
    accCode: "laporan_pembayaran_pembelian",
    parentCode: reportRoute.accCode,
});

export const rGroupRoute = createRoute({
    path: `${reportRoute.path}/group`,
    name: "common_report.group.",
    accCode: "laporan_grup",
    parentCode: reportRoute.accCode,
});

export const rGroupViewRoute = createRoute({
    path: `${rGroupRoute.path}/view`,
    name: "common_report.group.",
    code: "RG",
    accCode: "laporan_grup",
    parentCode: reportRoute.accCode,
});

export const rGroupViewItemStockRoute = createRoute({
    path: `${rGroupViewRoute.path}/item_stock`,
    name: "whs_itemstock.",
    code: "RGIS",
    accCode: "laporan_grup",
    parentCode: reportRoute.accCode,
});

export const rGroupViewItemInRoute = createRoute({
    path: `${rGroupViewRoute.path}/item_in`,
    name: "whs_itemin.",
    code: "RGII",
    accCode: "laporan_grup",
    parentCode: reportRoute.accCode,
});

export const rGroupViewItemOutRoute = createRoute({
    path: `${rGroupViewRoute.path}/item_out`,
    name: "whs_itemout.",
    code: "RGIO",
    accCode: "laporan_grup",
    parentCode: reportRoute.accCode,
});

// component
const Report = lazy(() => import("../page/report/Report"));
const RSellingInvoice = lazy(() => import("../page/report/selling_invoice/ReportSellingInvoice"));
const RSellingInvoiceDetail = lazy(() => import("../page/report/selling_invoice/ReportSellingInvoiceDetail"));
const RPurchaseInvoice = lazy(() => import("../page/report/purchase_invoice/ReportPurchaseInvoice"));
const RDO = lazy(() => import("../page/report/do/ReportDO"));
const RDODetail = lazy(() => import("../page/report/do/ReportDODetail"));
const RSO = lazy(() => import("../page/report/so/ReportSO"));
const RSODetail = lazy(() => import("../page/report/so/ReportSODetail"));
const RReturnCustomer = lazy(() => import("../page/report/return_customer/ReportReturnCustomer"));
const RReturnSupplier = lazy(() => import("../page/report/return_supplier/ReportReturnSupplier"));
const RSalesCommission = lazy(() => import("../page/report/commission/ReportSalesCommission"));
const RStockPrice = lazy(() => import("../page/report/stock_price/ReportStockPrice"));
const RDelivery = lazy(() => import("../page/report/delivery/DeliveryReport"));
const RHPP = lazy(() => import("../page/report/hpp/HPPReport"));
const RPaymentSales = lazy(() => import("../page/report/payment/PaymentSalesReport"));
const RPaymentPurch = lazy(() => import("../page/report/payment/PaymentPurchReport"));

const RGroup = lazy(() => import("../page/report/group/GroupReport"));
const RGroupView = lazy(() => import("../page/report/group/view/GroupReportDetail"));
const RGroupItemStockView = lazy(() => import("../page/report/group/view/GroupReportDetailItemStock"));
const RGroupItemInView = lazy(() => import("../page/report/group/view/GroupReportDetailItemIn"));
const RGroupItemOutView = lazy(() => import("../page/report/group/view/GroupReportDetailItemOut"));

export const reportListRoutes = [
    rSellingInvoiceRoute,
    rSellingInvoiceDetailRoute,
    rPurchInvoiceRoute,
    rDORoute, rDODetailRoute,
    rSORoute, rSODetailRoute,
    rReturnCustomerRoute,
    rReturnSupplierRoute,
    rSalesCommissionRoute,
    rStockPriceRoute,
    rDeliveryRoute,
    rGroupRoute,
    rHPPRoute,
    rPaymentSalesRoute,
    rPaymentPurchRoute,
];

export const reportMutationRoutes = [
    rGroupViewItemStockRoute, rGroupViewItemInRoute, rGroupViewItemOutRoute
]


export const reportRoutes = {
    element: <Report />,
    children: addHandleRoute([
        { ...rSellingInvoiceRoute, element: <RSellingInvoice /> },
        { ...rSellingInvoiceDetailRoute, element: <RSellingInvoiceDetail /> },
        { ...rPurchInvoiceRoute, element: <RPurchaseInvoice /> },
        { ...rDORoute, element: <RDO /> },
        { ...rDODetailRoute, element: <RDODetail /> },
        { ...rSORoute, element: <RSO /> },
        { ...rSODetailRoute, element: <RSODetail /> },
        { ...rReturnCustomerRoute, element: <RReturnCustomer /> },
        { ...rReturnSupplierRoute, element: <RReturnSupplier /> },
        { ...rSalesCommissionRoute, element: <RSalesCommission /> },
        { ...rStockPriceRoute, element: <RStockPrice /> },
        { ...rDeliveryRoute, element: <RDelivery /> },
        { ...rGroupRoute, element: <RGroup /> },
        {
            ...rGroupViewRoute,
            element: <RGroupView />,
            children: [
                { ...rGroupViewItemStockRoute, element: <RGroupItemStockView /> },
                { ...rGroupViewItemInRoute, element: <RGroupItemInView /> },
                { ...rGroupViewItemOutRoute, element: <RGroupItemOutView /> },
            ],
        },
        { ...rHPPRoute, element: <RHPP /> },
        { ...rPaymentSalesRoute, element: <RPaymentSales /> },
        { ...rPaymentPurchRoute, element: <RPaymentPurch /> },
    ]),
};
